export enum CustomerType {
  DNO = "DNO",
  Utility = "Utility",
  Engineering = "Engineering",
  Other = "Other",
}
